import { IConfig } from './types';

const config: IConfig = {
  env: 'local',
  productName: 'Quiz Master',
  productUrl: 'http://localhost:5900',
};

export default config;
